/**
 * ============================================================
 * custom-price-calculator.js
 * 100Totes — 动态价格明细
 *
 * 改编自 WholesaleTumblers 同款组件（S3），已完全按Totes品牌重新参数化（独立的全局变量名、
 * 独立的DOM id/class前缀，不与WT共用任何标识符）：
 *   - 无 window.__TOTES_PRICE_TIERS 时安全跳过（IIFE首行return），不报错
 *
 * 功能:
 *   1. Quantity 右侧显示: Total: $xxx.xx (加粗) / $x.xx ea × qty (小字)
 *   2. 页面加载自动设置 Quantity = MOQ
 *   3. variant.price 已包含 Imprint 加价，本组件不二次加价——unitPrice = base * (1 - discount%)
 *
 * 依赖:
 *   - window.__TOTES_PRICE_TIERS (由 custom-price-tiers.liquid 注入)
 *
 * 加载: layout/theme.liquid -> </body> 前
 * 创建: 2026-07-17
 *
 * 2026-07-21 下沉改造 (照WT wholesaletumblers 定稿移植, 见
 * shopify项目/100totes/audit/20260721_wt_improvements_porting/00_investigation.md):
 *   - 删除了 updateVariantLabels() / getSurcharge() 死代码 (与
 *     snippets/product-variant-options.liquid 服务端渲染 .totes-surcharge-label
 *     并存互不感知的双重冗余注入)。加价标签现在只由该 Liquid 文件 SSR 渲染。
 *   - updateLegendText 保留不删: 点击后到 SSR 新 HTML 落地之间仍有异步窗口,
 *     需要 JS 兜底更新同一 tick 内的 legend 文字, 已从轮询摘出, 只在
 *     change 事件里按需触发, 不在 setInterval(update, 100) 里跑。
 * ============================================================
 */
(function() {
  'use strict';

  var DATA = window.__TOTES_PRICE_TIERS;
  if (!DATA || !DATA.tiers || !DATA.tiers.length) return;

  function getBasePrice(vid) {
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].id === vid) return DATA.variants[i].price;
    }
    return DATA.variants[0].price;
  }

  function getSelectedImprint(vid) {
    var idx = DATA.imprintOptionIndex;
    if (idx < 0) return 'Blank';
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].id === vid) return DATA.variants[i].options[idx] || 'Blank';
    }
    return 'Blank';
  }

  function getDiscount(qty) {
    var d = 0;
    for (var i = 0; i < DATA.tiers.length; i++) {
      if (qty >= DATA.tiers[i].qty) d = DATA.tiers[i].discount;
    }
    return d;
  }

  function getCurrentVariantId() {
    var checked = document.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select');
    var selectedOptions = [];
    for (var i = 0; i < checked.length; i++) {
      selectedOptions.push(checked[i].value);
    }
    if (selectedOptions.length > 0) {
      for (var j = 0; j < DATA.variants.length; j++) {
        var v = DATA.variants[j];
        var match = true;
        for (var k = 0; k < v.options.length; k++) {
          if (selectedOptions.indexOf(v.options[k]) === -1) { match = false; break; }
        }
        if (match) return v.id;
      }
    }

    var p = new URLSearchParams(window.location.search);
    var v = p.get('variant');
    if (v) return parseInt(v, 10);

    var h = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (h) return parseInt(h.value, 10);

    return DATA.currentVariantId;
  }

  function fmt(n) { return '$' + n.toFixed(2); }

  function createWidget() {
    var widget = document.createElement('div');
    widget.id = 'totes-custom-calc';
    widget.className = 'totes-price-calc';

    widget.innerHTML =
      '<div style="text-align: right;">' +
        '<div class="totes-price-calc__total-line" style="font-size: 1.6rem; font-weight: 700; line-height: 1.3; color: #1a1a1a;">' +
          '<span style="font-size: 1.1rem; margin-right: 0.5rem;">Total:</span>' +
          '<span id="totes-calc-total"></span>' +
        '</div>' +
        '<div id="totes-calc-detail" class="totes-price-calc__detail-line" style="font-size: 1.1rem; color: #555; margin-top: 0.5rem; line-height: 1.4;"></div>' +
        '<div id="totes-calc-save-row" class="totes-price-calc__save-line" style="display:none; font-size: 0.95rem; color: #15803d; font-weight: 600; margin-top: 0.2rem; line-height: 1.4;">' +
          'You Save: <span id="totes-calc-save"></span>' +
        '</div>' +
      '</div>';

    return widget;
  }

  function insertWidget(widget) {
    var qtyInput = document.querySelector('quantity-input');
    if (!qtyInput) return;

    var wrapper = document.getElementById('totes-price-calc-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = 'totes-price-calc-wrapper';
      wrapper.style.display = 'flex';
      wrapper.style.justifyContent = 'space-between';
      wrapper.style.alignItems = 'flex-end';
      wrapper.style.gap = '1.5rem';
      wrapper.style.maxWidth = '44rem';
      wrapper.style.marginBottom = '1.5rem';

      qtyInput.parentNode.insertBefore(wrapper, qtyInput);

      var leftBox = document.createElement('div');
      var label = document.querySelector('label[for="' + qtyInput.querySelector('input').id + '"]') || document.querySelector('label.form__label');
      if (label) leftBox.appendChild(label);
      leftBox.appendChild(qtyInput);

      wrapper.appendChild(leftBox);
    }

    wrapper.appendChild(widget);
  }

  var lastValidQty = DATA.moq;

  function enforceState() {
    var vid = getCurrentVariantId();
    var imprint = getSelectedImprint(vid);
    var targetMoq = DATA.moq;
    if (DATA.variant_moqs && DATA.variant_moqs[imprint]) {
       targetMoq = DATA.variant_moqs[imprint];
    }

    var inp = document.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    if (inp && targetMoq > 1) {
      var current = parseInt(inp.value, 10) || 1;

      if (current < targetMoq && document.activeElement !== inp) {
        var restoreQty = (lastValidQty >= targetMoq) ? lastValidQty : targetMoq;
        inp.value = restoreQty;
        inp.setAttribute('value', restoreQty);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (current >= targetMoq) {
        lastValidQty = current;
      }
    }
  }

  function update() {
    enforceState();

    var calcEl = document.getElementById('totes-custom-calc');
    if (!calcEl) {
       insertWidget(createWidget());
    }

    var vid = getCurrentVariantId();
    var imprint = getSelectedImprint(vid);
    var targetMoq = DATA.moq;
    if (DATA.variant_moqs && DATA.variant_moqs[imprint]) {
       targetMoq = DATA.variant_moqs[imprint];
    }

    var qtyInput = document.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || targetMoq) : targetMoq;

    var base = getBasePrice(vid);
    var discountPct = getDiscount(qty);

    /* variant.price 已含 Imprint 加价；此处不得再加 surcharge，只按折扣计算 */
    var unitPrice = base * (1 - discountPct / 100);
    var subtotal = unitPrice * qty;
    var fullPrice = base * qty;
    var youSave = fullPrice - subtotal;

    var elTotal = document.getElementById('totes-calc-total');
    var elDetail = document.getElementById('totes-calc-detail');
    var elSave = document.getElementById('totes-calc-save');
    var elSaveRow = document.getElementById('totes-calc-save-row');

    /* [2026-10-27 配件加购] 配件按每个包计价、不打折（方案 C），加在折后小计之后 */
    var addonCents = (window.TotesAddons && typeof window.TotesAddons.perBagCents === 'function') ? window.TotesAddons.perBagCents() : 0;
    if (!(addonCents >= 0)) addonCents = 0;
    var addonTotal = addonCents * qty / 100;
    if (elTotal) elTotal.textContent = fmt(subtotal + addonTotal);
    if (elDetail) elDetail.textContent = fmt(unitPrice) + ' ea × ' + qty + ' qty' + (addonCents ? ' + add-ons ' + fmt(addonCents / 100) + ' ea' : '');

    if (youSave > 0.005 && elSave && elSaveRow) {
      elSave.textContent = fmt(youSave);
      elSaveRow.style.display = '';
    } else if (elSaveRow) {
      elSaveRow.style.display = 'none';
    }
  }

  var widget = createWidget();
  insertWidget(widget);
  update();

  setInterval(update, 100);

  var qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
  }

  var radios = document.querySelectorAll('fieldset input[type="radio"]');
  for (var r = 0; r < radios.length; r++) {
    radios[r].addEventListener('change', function() { setTimeout(update, 50); });
  }

  window.addEventListener('popstate', function() { setTimeout(update, 50); });

  var hiddenId = document.querySelector('input[name="id"]');
  if (hiddenId) {
    new MutationObserver(function() { update(); })
      .observe(hiddenId, { attributes: true, attributeFilter: ['value'] });
  }

  function updateLegendText(fieldset) {
    var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    var legend = fieldset.querySelector('legend.form__label');

    if (checkedInput && legend && !legend.querySelector('[data-selected-swatch-value]')) {
      var optionName = legend.textContent.split(':')[0].trim();
      legend.innerHTML = optionName + ': <span style="font-weight: normal; margin-left: 4px;" class="custom-selected-value">' + checkedInput.value + '</span>';
    }
  }

  var fieldsets = document.querySelectorAll('fieldset');
  for (var f = 0; f < fieldsets.length; f++) {
    var hasRadio = fieldsets[f].querySelector('input[type="radio"]');
    if (hasRadio) {
      updateLegendText(fieldsets[f]);
    }
  }

  document.addEventListener('change', function(e) {
    if (e.target && e.target.tagName === 'INPUT' && e.target.type === 'radio') {
      var fieldset = e.target.closest('fieldset');
      if (fieldset) {
        setTimeout(function() { updateLegendText(fieldset); }, 10);
      }
    }
  });

})();
